import { OnEvent, Service } from '@toeverything/infra';

import { AccountChanged } from '../events/account-changed';
import { UserCreditsDetail } from '../entities/user-credits-detail';

@OnEvent(AccountChanged, e => e.onAccountChanged)
export class UserCreditsDetailsService extends Service {
  creditsDetail = this.framework.createEntity(UserCreditsDetail);

  private onAccountChanged() {
    this.creditsDetail.revalidate();
  }
}
